// import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { Auth0Provider } from "@auth0/auth0-react";

const domain = import.meta.env.VITE_REACT_APP_AUTH0_DOMAIN as string;
const clientId = import.meta.env.VITE_REACT_APP_AUTH0_CLIENT_ID as string;

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <Auth0Provider
    useRefreshTokens={true} // Enable refresh tokens,
    cacheLocation="localstorage" // Store tokens in localStorage for better persistence, this helps allow users to stay logged in on refresh or navigating to landing page. **security issue here,  vulnerable to XSS (Cross-Site Scripting) attacks, an attacker could steal the token, this is temporary solution**
    // cacheLocation="memory" // Default: safer than localStorage
    domain={domain}
    clientId={clientId}
    authorizationParams={{
      redirect_uri: "http://localhost:5173/home", // after login, redirect to home page
      // redirect_uri: "https://fiestr.com/", // after login, redirect to home page
      audience: "https://fiestr.com/api",
      scope: "openid email profile",
    }}
  >
    <App />
  </Auth0Provider>
  // </React.StrictMode>
);
//  // redirect_uri: "https://fiestr.com/", // for production
